import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { LocaleFacet } from '#/modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from '#/modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from '#/modules/search/components/Facet/OrgAreasOfFocusFacet';
import { OrgTypeFacet } from '#/modules/search/components/Facet/OrgTypeFacet';
import { RadiusFacet } from '#/modules/search/components/Facet/RadiusFacet';
import { RecencyFacet } from '#/modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from '#/modules/search/components/Refinements/SearchRefinements';

import { EducationFacet } from '../EducationFacet';
import { EmploymentTypeFacet } from '../EmploymentTypeFacet';
import { JobFamilyFilter } from '../JobFamilyFilter';
import { JobKeywordsFacet } from '../JobKeywordsFacet';
import { ProfessionalLevelFacet } from '../ProfessionalLevelFacet';
import { SalaryListedFilter } from '../SalaryListedFilter';

export function SearchJobsRefinements() {
  const { locale } = useI18n();

  return (
    <SearchRefinements
      listingType="JOB"
      renderFacets={({ variant }) => {
        switch (locale) {
          case I18nLocale.EN:
            return (
              <>
                <JobFamilyFilter />
                <LocationTypeFacet variant={variant} />
                <SalaryListedFilter variant={variant} />
                <EmploymentTypeFacet variant={variant} />
                <ProfessionalLevelFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <EducationFacet variant={variant} />
                <JobKeywordsFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
                <LocaleFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.ES:
            return (
              <>
                <LocaleFacet variant={variant} />
                <JobFamilyFilter />
                <LocationTypeFacet variant={variant} />
                <SalaryListedFilter variant={variant} />
                <JobKeywordsFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <RecencyFacet variant={variant} />
                <EducationFacet variant={variant} />
                <ProfessionalLevelFacet variant={variant} />
                <EmploymentTypeFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.PT:
            return (
              <>
                <LocaleFacet variant={variant} />
                <JobFamilyFilter />
                <LocationTypeFacet variant={variant} />
                <SalaryListedFilter variant={variant} />
                <JobKeywordsFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <ProfessionalLevelFacet variant={variant} />
                <EducationFacet variant={variant} />
                <EmploymentTypeFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );
        }
      }}
    />
  );
}
